import workspace from "../../workspace";
import COLOR_THEMES from "../../../store/colorThemes";
import sqftConfig from "../../../store/sqftConfig";
import store from "../../../../../../../store";
import SeamTool from "./slabParts/seamTool";
import {RENDER_TEMPLATES, SHAPE_PART_ID, SIDEBAR_SLAB_SEAM_BUTTONS} from "../../../../../constants";
import RenderParts from "../../../helpers/renderParts";
import ShapeMeasurementArrows from "./shapeMeasurementArrows";
import ShapeAbsolute from "./shapeAbsolute";
import workspaceControllers from "../../../store/workspaceControllers";
import {getPointField} from "../../../../../helpers/sqftHelper";
import RenderFigures from "../../../helpers/renderFigures";

class ShapeSlab {
  __shape;
  __seamTool;
  __intersectionPoints = [];
  __minLengthToIntersectionPoints;
  __absolutePos = null; //not used?
  shapeAbsolute = new ShapeAbsolute(this);

  constructor(shape) {
    this.__shape = shape;
    this.__seamTool = new SeamTool(shape);
    this.__measurementArrows = new ShapeMeasurementArrows(shape);
  }
  setSlabPos(pos) {
    this.__shape.slabPos = pos
  }
  setParentId(parentId) {
    this.__shape.shapeParent = parentId
  }
  setRotationDegreesSlab(rotationDegrees) {
    this.__shape.rotatedDegreesSlab = rotationDegrees
  }
  addSeamPieceVertical = (mousePos) => {
    this.__seamTool.addSeamPieceVertical(mousePos);
    workspaceControllers.snappedShapeGroups.updateShapesSnappedGroups(false);
  };
  addSeamPieceHorizontal = (mousePos) => {
    this.__seamTool.addSeamPieceHorizontal(mousePos);
    workspaceControllers.snappedShapeGroups.updateShapesSnappedGroups(false);
  };
  setAbsolutePos = (pos) => {
    //this.__absolutePos = pos;
    this.shapeAbsolute.setAbsolutePos(pos);
  };
  getAbsolutePosition = () => {
    //return this.__absolutePos;
    return this.shapeAbsolute.getAbsolutePosition();
  };
  getPosition = () => {
    let absolutePos = this.getAbsolutePosition();

    if (absolutePos) {
      return absolutePos
    }

    return this.__shape.slabPos;
  };
  setIntersectionsPoints = (points) => {
    this.__intersectionPoints = points;
  };
  setMinLengthToIntersectionPoints = (length) => {
    this.__minLengthToIntersectionPoints = length;
  };
  resetShapeSeams = () => {
    for (let i = this.__shape.shapePieces.length - 1; i >= 0; i--) {
      let shp = workspace.getShapeById(this.__shape.shapePieces[i]);
      if (shp.shapePieces) {
        shp.shapeSlab.resetShapeSeams();
      }
      workspace.removeShape(shp);
    }
    this.__shape.shapePieces.splice(0, this.__shape.shapePieces.length);
  };
  import = (data) => {
    this.shapeAbsolute.setAbsolutePos(data ? data.absolutePosition : null);
  }
  export = () => {
    return {
      absolutePosition: this.getAbsolutePosition()
    }
  }

  render = (ctx,
            staticOffset = null,
            strokeTemplate= RENDER_TEMPLATES.default,
            fillTemplate = RENDER_TEMPLATES.accordingToFeature
  ) => {
    if (workspace && workspace.getState().loading) return;
    if (this.__shape.partId === SHAPE_PART_ID.slabPlaceHolder) {
      RenderParts.drawDiagonalStripes(ctx, this.__shape, 2);
    } else {
      RenderParts.drawShapeBorders(ctx, staticOffset, strokeTemplate, fillTemplate, this.__shape);
    }
    const reduxState = store.getState()
    let isMeasurementVisibleInSlabMode = reduxState.sqftSlabState.isMeasurementVisibleInSlabMode;
    if (isMeasurementVisibleInSlabMode) {
      this.renderMeasurementArrows(ctx);
    }
    this.renderSeamLinesOnHover(ctx);
    this.renderSeamCutPoints(ctx);
  };

  renderSeamLinesOnHover = (ctx) => {
    if (this.__shape.isHovering() && workspace.getHoveredSqftShape() === this.__shape ) {
      let sqftMenuState = store.getState().sqftMenuState;
      if (sqftMenuState.activeButton === SIDEBAR_SLAB_SEAM_BUTTONS.addSeamVertical) {
        this.__seamTool.seamToolRender.renderSeamVerticalIntersection(ctx);
      } else if (sqftMenuState.activeButton === SIDEBAR_SLAB_SEAM_BUTTONS.addSeamHorizontal) {
        this.__seamTool.seamToolRender.renderSeamHorizontalIntersection(ctx);
      }
    }
  }

  renderSeamCutPoints = (ctx) => {
    const strokeStyle = '#e01333';
    for (const seamCutPoint of this.__shape.seamCutPoints) {
      const seamCutPointOnField = getPointField(seamCutPoint.x, seamCutPoint.y, this.__shape);
      RenderFigures.renderCircle(seamCutPointOnField, 4, 1, strokeStyle, strokeStyle);
      RenderFigures.renderCircle(seamCutPointOnField, 7, 1, strokeStyle);
    }
    if (this.__shape.seamCutPoints.length === 2) {
      const startPoint = this.__shape.seamCutPoints[0];
      const endPoint = this.__shape.seamCutPoints[1];
      const startPointOnField = getPointField(startPoint.x, startPoint.y, this.__shape);
      const endPointOnField = getPointField(endPoint.x, endPoint.y, this.__shape);
      ctx.moveTo(startPointOnField.x, startPointOnField.y);
      ctx.lineTo(endPointOnField.x, endPointOnField.y);
      ctx.strokeStyle = strokeStyle;
      ctx.stroke();
    }
  }

  renderLinesWithoutStroke = (ctx, staticOffset = null, sqftMode) => {
    if (workspace && workspace.getState().loading) return;
    let lines = this.__shape.getLines();
    ctx.lineWidth = 2;
    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active;
    for (let i = 0; i < lines.length; i++) {
      lines[i].staticOffset = staticOffset;
      lines[i].render(ctx, i > 0, sqftMode);
      lines[i].staticOffset = null;
    }
  };

  renderMeasurementArrows = (ctx) => {
    const snappedShapeGroup = this.shapeAbsolute.getSnappedShapeGroup();
    //We will render measurement arrows only if there are no shapes snaps to the current shape;
    if (snappedShapeGroup !== null) {
      const snappedShapes = workspaceControllers.snappedShapeGroups.getSnappedShapes(snappedShapeGroup);
      if (snappedShapes.length > 1) {
        return
      }
    }

    this.__measurementArrows.render(ctx);
  };
}

export default ShapeSlab
